// Counterpart of webapp/src/store/clientConfig.ts

import {create} from 'zustand'
import {ClientConfig, defaultClientConfig} from '../types/user'
import client from '../api/client'

type ClientConfigState = {
    config: ClientConfig
    loadClientConfig: () => Promise<ClientConfig>
}

export const useClientConfig = create<ClientConfigState>((set) => ({
    config: defaultClientConfig,

    async loadClientConfig() {
        const config = await client.getClientConfig()
        if (config) {
            set({config})
            return config
        }
        return defaultClientConfig
    },
}))
